module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticStyle: {
      "background": "#ffffff",
      "width": "100%",
      "height": "3.2em",
      "top": "0",
      "position": "fixed",
      "z-index": "9999",
      "padding-top": "3px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #e7e7e7",
      "display": "inline",
      "text-align": "center"
    }
  }, [(_vm.navw) ? _c('a', {
    staticStyle: {
      "float": "left",
      "padding-left": "8px",
      "color": "#000000",
      "font-size": "24px",
      "font-weight": "500",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.hide_nav
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]) : _c('a', {
    staticStyle: {
      "float": "left",
      "padding-left": "8px",
      "color": "#000000",
      "font-size": "24px",
      "font-weight": "500",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.show_nav
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin": "-0.8em 1em",
      "color": "#000000"
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "25px"
    },
    attrs: {
      "src": "/static/assets/images/logo-black.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "font-size": "20px",
      "cursor": "pointer",
      "padding-top": "5px"
    },
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "main-nav-bar"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/timeline"
    }
  }, [_vm._v("Shop")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Book Tickets")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Events")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Tour")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90aa3cc6"}!./src/pages/MainHeader/template.html
// module id = 272
// module chunks = 0